import axios from 'axios'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {
   allCoins: [],
   totalBalance: 0,
   isLoading: false,
   errorMessage: null,
}

export const fetchAllCoins = createAsyncThunk(
   'coins/fetchAllCoins',
   async (_, thunkAPI) => {
      try {
         const state = thunkAPI.getState()

         const response = await axios.post(
            //`https://wsn-0x29b1d432a40f40f5418da2d4abf740e5e491629b-authority.stackos.io/api/swap/listAllTokens`
            `${process.env.REACT_APP_API_URL}/api/wallet/getBalance`,
            {
               publicKey: state.user.publicKey,
            }
         )

         const temp = response.data.data
         const balance = response.data.total

         return { data: temp, balance: balance }
      } catch (err) {
         return thunkAPI.rejectWithValue(err.message)
      }
   }
)

export const coinsSlice = createSlice({
   name: 'coins',
   initialState,
   extraReducers: builder => {
      builder.addCase(fetchAllCoins.fulfilled, (state, action) => {
         state.allCoins = action.payload.data
         state.totalBalance = action.payload.balance
         state.isLoading = false
      })
      builder.addCase(fetchAllCoins.pending, state => {
         state.isLoading = true
      })
      builder.addCase(fetchAllCoins.rejected, state => {
         state.isLoading = false
         state.errorMessage = 'Something went wrong!'
      })
   },
})

export default coinsSlice.reducer
